// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Section wrapper (shared by Configuracion + Facturacion) ── */
.cfg-section {
  margin-bottom: 36px;
}

.cfg-section-title {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-figure);
  margin: 0 0 4px;
  letter-spacing: -0.005em;
  color: var(--text);
}

.cfg-section-sub {
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  margin: 0 0 18px;
}

/* ── Field grid ── */
/* Fields flow into as many columns as fit and wrap to new rows (like cards)
   instead of a fixed 2-up that overlaps as the panel widens/narrows. */
.cfg-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));
  gap: 18px 32px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  padding: 22px 24px;
}

.cfg-field-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

/* Grid children must be allowed to shrink below their content width, or long
   mono values (emails, RUT, addresses) force horizontal overflow. */
.cfg-field-display {
  min-width: 0;
}

.cfg-field-display__label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.cfg-field-display__value {
  font-size: var(--fs-note);
  color: var(--text);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cfg-field-display__value.muted {
  color: var(--text-secondary);
}

.cfg-field-display__value.mono {
  font-family: var(--mono);
  font-size: var(--fs-ui);
}

.cfg-section-action {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 560px) {
  .cfg-field-grid,
  .cfg-field-grid.cols-3 {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 18px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/FieldDisplay/FieldDisplay.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;uEACuE;AACvE;EACE,aAAa;EACb,sEAAsE;EACtE,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;oEACoE;AACpE;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Section wrapper (shared by Configuracion + Facturacion) ── */\n.cfg-section {\n  margin-bottom: 36px;\n}\n\n.cfg-section-title {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-figure);\n  margin: 0 0 4px;\n  letter-spacing: -0.005em;\n  color: var(--text);\n}\n\n.cfg-section-sub {\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n  margin: 0 0 18px;\n}\n\n/* ── Field grid ── */\n/* Fields flow into as many columns as fit and wrap to new rows (like cards)\n   instead of a fixed 2-up that overlaps as the panel widens/narrows. */\n.cfg-field-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));\n  gap: 18px 32px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  padding: 22px 24px;\n}\n\n.cfg-field-grid.cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n/* Grid children must be allowed to shrink below their content width, or long\n   mono values (emails, RUT, addresses) force horizontal overflow. */\n.cfg-field-display {\n  min-width: 0;\n}\n\n.cfg-field-display__label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.cfg-field-display__value {\n  font-size: var(--fs-note);\n  color: var(--text);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.cfg-field-display__value.muted {\n  color: var(--text-secondary);\n}\n\n.cfg-field-display__value.mono {\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n}\n\n.cfg-section-action {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 560px) {\n  .cfg-field-grid,\n  .cfg-field-grid.cols-3 {\n    grid-template-columns: 1fr;\n    gap: 14px;\n    padding: 18px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
